import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import { Button, Image } from 'components/ui';
import { colors } from 'style/config';

/**
 * Paze Pill Button - Release 4 Style
 * Renders as a pill-shaped button with Paze logo
 */
const PazePill = props => {
    const { isPazeEnabledForThisOrder, handlePaymentClick } = props;

    // Don't render if Paze is not enabled
    if (!isPazeEnabledForThisOrder) {
        return null;
    }

    return (
        <Button
            variant='primary'
            onClick={handlePaymentClick}
            data-at={Sephora.debug.dataAt('paze_button')}
            aria-label='Pay with Paze'
            css={styles}
            width={['151px', '151px', '100%']}
        >
            <Image
                src='/img/ufe/logo-paze-white.svg'
                alt=''
                aria-hidden='true'
                height='16px'
                width='52px'
            />
        </Button>
    );
};

const styles = {
    backgroundColor: colors.pazeBlue,
    borderRadius: '22px',
    height: '44px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '10px 24px',
    gap: '12px',
    flexShrink: 0,
    '&:hover': {
        backgroundColor: colors.pazeBlue
    }
};

export default wrapFunctionalComponent(PazePill, 'PazePill');
